import React from "react";
import { Row, Col, Glyphicon } from "react-bootstrap";
import Api from "js/utilities/fnapi-client";
import UserHandler from "js/utilities/user-handler";
import * as config from "../../config";
import FontAwesome from "react-fontawesome";

export default React.createClass({

  getInitialState() {
    return {
      deleting: false,
      removed: false,
      sshError: "",
      sshSuccess: "",
    };
  },

  render: function() {
    return (
      <div key={this.props.type} className={"form-row" + (this.state.removed ? " removed" : "")}>
        <span className="form-label">
          {this.props.name}
        </span>
        <span className="form-value">
            Fingerprint: {this.props.fingerprint}
        </span>
        <span className="form-icon">
          { this.props.canEdit &&
            <button className="btn btn-download btn-new" onClick={this.handleRemoveSshKey.bind(this, this.props.guid) }>Delete</button>
          }
        </span>
      </div>
    );
  },

  handleRemoveSshKey(guid, event) {
    event.preventDefault();
    this.props.action("", "");

    if (window.confirm('Are you sure you wish to delete this SSH Key?')) {
      this.setState({deleting: true});
      this.deleteSshKey(guid)
    }
  },

  deleteSshKey: function(guid) {
    event.preventDefault();
    this.props.action("", "");

    if(guid == "") {
      this.props.action("Please try again", "");
      return
    }

    // Instantiate Loggly
    _LTracker.push({
      "logglyKey": "98508576-85af-467e-8713-9ae93891800c",
      "tag" : "sdksite_debug_logs",
      "sendConsoleErrors": true
    });

    UserHandler.logToLogglySimple("license-keys.jsx - deleteSshKey - start");

    var method = "DELETE";
    var fullURL = config.API_PREFIX + "application/" + this.props.appToken + "/sshkey/" + guid;

    var reqBody = [];
    var requestStartTime = Date.now();
    var request = new XMLHttpRequest();
    request.open(method, fullURL, true);
    request.setRequestHeader("Content-Type", "application/json");
    request.setRequestHeader("Accept", "application/json");

    let token = UserHandler.getToken();
    if (token){
      request.setRequestHeader("X-User-Token",token);
    }

    var reqHeaders = {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-User-Token": token
    };

    var localContextThis = this;

    request.onerror = function() {
      UserHandler.logToLogglySimple("license-keys.jsx - deleteSshKey - onerror 1 - fatal - 3211");
      var apiCallTimeEndToEnd = Date.now() - requestStartTime;

      UserHandler.logToLogglyWithAPIResponse(
        "license-keys.jsx - deleteSshKey - onerror 2 - fatal - 3211",
        method,
        fullURL,
        reqHeaders,
        reqBody,
        "No responseText when errored.",
        apiCallTimeEndToEnd
      );

      localContextThis.props.action("There was an error (3211) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.", "");
      return;
    };

    request.onload = function() {
      UserHandler.logToLogglySimple("license-keys.jsx - deleteSshKey - onload 1");
      var apiCallTimeEndToEnd = Date.now() - requestStartTime;

      UserHandler.logToLogglyWithAPIResponse(
        "license-keys.jsx - deleteSshKey - onload 2",
        method,
        fullURL,
        reqHeaders,
        reqBody,
        request.responseText,
        apiCallTimeEndToEnd
      );

      // Check response for non-happy-path flags
      var responseJSON;
      try {
        responseJSON = JSON.parse(request.responseText);
      }
      catch (e) {
        UserHandler.logToLogglySimple("license-keys.jsx - deleteSshKey - onload - JSON.parse error - fatal - 3212");
        UserHandler.logToLogglySimple("license-keys.jsx - deleteSshKey - onload - JSON.parse error - fatal - 3212 - error: " + e);
        localContextThis.props.action("There was an error (3212) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.", "");
        return;
      }

      if(!responseJSON.meta || !responseJSON.meta.ok) {
        localContextThis.props.action("There was an error (3215) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.", "");
        UserHandler.logToLogglySimple("license-keys.jsx - deleteSshKey - onload - malformed response meta - fatal - 3205");
        return;
      }

      if(responseJSON && responseJSON.meta && responseJSON.meta.ok) {
          // Happy path
          if(responseJSON.data == null) {
            UserHandler.logToLogglySimple("license-keys.jsx - deleteSshKey - onload - SSH key not available - fatal - 3216");
            localContextThis.props.action("There was an error (3216) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.", "");
          }
          else if(responseJSON.data && responseJSON.data.sshKeys) {
            var sshError = "";

            // If a user deletes an SSH key, but a key with the same fingerprint (ie, the same key) exists belonging to a
            // different application, we need to alert them as this key has not ---actually--- been deleted from AWS, it's
            // only been deleted from the ZAPI database
            if (responseJSON.meta.message){
              sshError = responseJSON.meta.message;
            }
            localContextThis.props.action(sshError, "SSH key deleted successfully");

            // localContextThis.props.updateSshKeys(responseJSON.data.sshKeys);
            localContextThis.setState({
              "removed": true
            })
          }
          else {
            UserHandler.logToLogglySimple("license-keys.jsx - deleteSshKey - onload - email send response incorrect 2 - fatal - 3217");
            localContextThis.props.action("There was an error (3217) contacting FaceTec servers. FaceTec support has been notified of the issue.  Please try again or email support@facetec.com for assistance.", "");
          }
          return;
      }
    }
    request.send(JSON.stringify(reqBody));
    UserHandler.logToLogglySimple("license-keys.jsx - deleteSshKey - sent");
  },
});



// WEBPACK FOOTER //
// ./src/js/components/account/account-table-sshkey-row.jsx